import React from "react";

export function EmailIcon({ ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="12.3605" cy="12.1533" rx="11.8605" ry="12" fill="black" />
      <path
        d="M13.5182 12.2344L18.7937 7.50304C18.6323 7.40888 18.4489 7.35899 18.262 7.3584H6.45911C6.27223 7.35899 6.08882 7.40888 5.9274 7.50304L11.2029 12.2344C11.8536 12.8458 12.8676 12.8458 13.5182 12.2344Z"
        fill="white"
      />
      <path
        d="M19.2442 7.95904L15.142 11.6381L19.2742 16.2923C19.3801 16.0869 19.4351 15.8591 19.4345 15.628V8.67885C19.4355 8.42635 19.3698 8.17806 19.2442 7.95904Z"
        fill="white"
      />
      <path
        d="M5.47692 7.95904C5.35128 8.17806 5.28566 8.42636 5.28666 8.67885V15.628C5.28607 15.8591 5.34104 16.0869 5.44693 16.2922L9.57917 11.6381L5.47692 7.95904Z"
        fill="white"
      />
      <path
        d="M13.8903 12.7607C13.0305 13.5686 11.6907 13.5686 10.8308 12.7607L10.0495 12.06L5.86933 16.7681C6.04389 16.8849 6.24904 16.9477 6.45911 16.9486H18.2621C18.4721 16.9477 18.6773 16.8849 18.8518 16.7681L14.6717 12.06L13.8903 12.7607Z"
        fill="white"
      />
    </svg>
  );
}
